import { Module } from 'vuex';
import { RootState } from '@/store/index';
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

import type { State } from './state';

export { State };

const store: Module<State, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default store;
